export default onClose => (event, reason) => reason != 'backdropClick' && onClose(event, reason);
